import { IStatisticColumnDef } from '@fi-app/statistic2/statistic2-report-view/statistic2-report-view';

export enum Statistic2ReportColumn {
    Icon = 0,
    ObjectName = 1,
    Area = 2,
    Unit = 3,
    Roles = 4,
    PercentageValue = 5,
    Value = 6,
    NewItemsValue = 7,
    StartDate = 8,
    EndDate = 9,
    TimeOnPage = 10,
    LatestActivity = 11,
    VisitsColumn = 12,
    DeviceType = 13,
    MobileAppLoginsCount = 14,
    WebLoginsCount = 15,
    CurrentUnitVisitsColumn = 16,
    FileViewsCount = 17,
    FileDownloadsCount = 18,
    FileViewsActivity = 19,
}

export enum Statistic2ReportColumnPropertyName {
    Icon = 'UserProfile',
    ObjectName = 'ObjectName',
    Area = 'AreaName',
    Unit = 'BusinessUnitName',
    Roles = 'Roles',
    PercentageValue = 'ValuePercentage',
    Value = 'Value',
    NewItemsValue = 'NewItemsValue',
    StartDate = 'StartDate',
    EndDate = 'EndDate',
    TimeOnPage = 'TimeOnPage',
    LatestActivity = 'EndDate',
    VisitsColumn = 'Visits',
    DeviceType = 'DeviceType',
    MobileAppLoginsCount = 'MobileAppLoginsCount',
    WebLoginsCount = 'WebLoginsCount',
    CurrentUnitVisitsColumn = 'CurrentUnitVisitsCount',
    FileViewsCount = 'FileViewsCount',
    FileDownloadsCount = 'FileDownloadsCount',
    FileViewsActivity = 'FileViewsActivity',
}

export const Statistic2ReportColumnsDef: IStatisticColumnDef[] = [
    {
        id: Statistic2ReportColumn.Icon,
        propertyName: Statistic2ReportColumnPropertyName.Icon,
    },
    {
        id: Statistic2ReportColumn.ObjectName,
        propertyName: Statistic2ReportColumnPropertyName.ObjectName,
    },
    {
        id: Statistic2ReportColumn.Area,
        propertyName: Statistic2ReportColumnPropertyName.Area,
    },
    {
        id: Statistic2ReportColumn.Unit,
        propertyName: Statistic2ReportColumnPropertyName.Unit,
    },
    {
        id: Statistic2ReportColumn.Roles,
        propertyName: Statistic2ReportColumnPropertyName.Roles,
    },
    {
        id: Statistic2ReportColumn.PercentageValue,
        propertyName: Statistic2ReportColumnPropertyName.PercentageValue,
    },
    {
        id: Statistic2ReportColumn.Value,
        propertyName: Statistic2ReportColumnPropertyName.Value,
    },
    {
        id: Statistic2ReportColumn.NewItemsValue,
        propertyName: Statistic2ReportColumnPropertyName.NewItemsValue,
    },
    {
        id: Statistic2ReportColumn.StartDate,
        propertyName: Statistic2ReportColumnPropertyName.StartDate,
    },
    {
        id: Statistic2ReportColumn.EndDate,
        propertyName: Statistic2ReportColumnPropertyName.EndDate,
    },
    {
        id: Statistic2ReportColumn.TimeOnPage,
        propertyName: Statistic2ReportColumnPropertyName.TimeOnPage,
    },
    {
        id: Statistic2ReportColumn.LatestActivity,
        propertyName: Statistic2ReportColumnPropertyName.LatestActivity,
    },
    {
        id: Statistic2ReportColumn.VisitsColumn,
        propertyName: Statistic2ReportColumnPropertyName.VisitsColumn,
    },
    {
        id: Statistic2ReportColumn.DeviceType,
        propertyName: Statistic2ReportColumnPropertyName.DeviceType,
    },
    {
        id: Statistic2ReportColumn.MobileAppLoginsCount,
        propertyName: Statistic2ReportColumnPropertyName.MobileAppLoginsCount,
    },
    {
        id: Statistic2ReportColumn.WebLoginsCount,
        propertyName: Statistic2ReportColumnPropertyName.WebLoginsCount,
    },
    {
        id: Statistic2ReportColumn.CurrentUnitVisitsColumn,
        propertyName: Statistic2ReportColumnPropertyName.CurrentUnitVisitsColumn,
    },
    {
        id: Statistic2ReportColumn.FileViewsCount,
        propertyName: Statistic2ReportColumnPropertyName.FileViewsCount,
    },
    {
        id: Statistic2ReportColumn.FileDownloadsCount,
        propertyName: Statistic2ReportColumnPropertyName.FileDownloadsCount,
    },
    {
        id: Statistic2ReportColumn.FileViewsActivity,
        propertyName: Statistic2ReportColumnPropertyName.FileViewsActivity,
    },
];
